export default {
    parts: [],
    baseStyle: (props) => ({
        wrapper: {
            backgroundColor: props?.BackgroundColorPicker || 'red',
            ratio: props?.gridSize === '1x1' ? 19 / 28 : 691 / 503,
            marginBottom: {lg: 2},
            width: '100%'
        },
        ratioContainer: {
            display: 'block'
        }
    })
}
